import React, { useContext, useEffect, useState } from "react";
import "./Setting.css";
import SettingSideBar from "./SettingSideBar";
import { MyContext } from "../Context/SharedStateContext";
import NewSidebar from "../newSideBar";
import Navbar from "../NavBar";

const options = [
  {
    label: "Ocean Blue",
    gradient: "linear-gradient(to bottom right, #2A27DA, #00CCFF)",
  },
  {
    label: "Soft Purple",
    gradient: "linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)",
  },
  {
    label: "Sunset Orange",
    gradient: "linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
  },
  {
    label: "Sky Blue",
    gradient: "linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    label: "Berry Pink",
    gradient: "linear-gradient(120deg, #a6c0fe 0%, #f68084 100%)",
  },
  {
    label: "Aqua Marine",
    gradient: "linear-gradient(to right, #4facfe 0%, #00f2fe 100%)",
  },
  {
    label: "Mint Green",
    gradient: "linear-gradient(to right, #43e97b 0%, #38f9d7 100%)",
  },
  {
    label: "Deep Purple",
    gradient: "linear-gradient(to top, #30cfd0 0%, #330867 100%)",
  },
  {
    label: "Coral Pink",
    gradient: "linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
  },
];

function ChatIcon() {
  const {
    iconText,
    setIconText,
    position,
    setPosition,
    selectedColor,
    setSelectedColor,
    firstChat,
    setFirstChat,
    botFirstChat,
    setBotFirstChat,
    removeBranding,
    removeBrandingChecked,
    setRemoveBrandingChecked,
  } = useContext(MyContext);
  const [isSaving, setIsSaving] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const localURL = localStorage.getItem("shopURL");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  useEffect(() => {
    const bootstrap = require("bootstrap");
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const handleSelect = (option) => {
    setSelectedColor(option.gradient);
    setIsOpen(false);
  };

  const handleColorChange = (event) => {
    setSelectedColor(event.target.value);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/save-appearence`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            widgetPosition: position,
            iconText,
            selectedColor,
            firstChat,
            botFirstChat,
            removeBrandingChecked,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save appearance settings");
      }
      if (!response.ok) {
        throw new Error("Failed to save appearance settings");
      }
  
      // Show success notification
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error(error);
      // alert("Error saving appearance settings.");
      setShowError(true);
    setTimeout(() => setShowError(false), 3000);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCheckboxChange = (e) => {
    setRemoveBrandingChecked(e.target.checked);
  };

  return (
    <div className="d-flex flex-column w-100">
      <Navbar />
      <div className="d-flex">
        <NewSidebar />
        <div style={{ display: "flex", flex:1}}>
          <SettingSideBar />
          <div className="main-setting-container w-100">
            <div className="setting-header">
              <h3 className="chat-title">Appearance Settings</h3>
              <p className="setting-subtitle">
                Customize how your chat widget looks and behaves
              </p>
            </div>

            <div className="settings-grid">
              {/* Widget Position */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Widget Position
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Select where the chat widget should appear on the screen."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <div className="position-options">
                  <div
                    className={`position-option ${
                      position === "left" ? "selected" : ""
                    }`}
                    onClick={() => setPosition("left")}
                  >
                    <div className="position-preview left">
                      <div className="widget-demo"></div>
                    </div>
                    <span>Left Side</span>
                  </div>
                  <div
                    className={`position-option ${
                      position === "right" ? "selected" : ""
                    }`}
                    onClick={() => setPosition("right")}
                  >
                    <div className="position-preview right">
                      <div className="widget-demo"></div>
                    </div>
                    <span>Right Side</span>
                  </div>
                </div>
              </div>

              {/* Chat Icon Text */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Chat Icon Text
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Customize the text displayed next to the chat icon."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <input
                  type="text"
                  className="form-input"
                  placeholder="e.g. 'Need help?' or 'Chat with us'"
                  value={iconText}
                  onChange={(e) => setIconText(e.target.value)}
                />
              </div>

              {/* Manual Welcome Message */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Manual Welcome Message
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Set the first message that appears when a user starts a manual chat."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <input
                  type="text"
                  className="form-input"
                  placeholder="e.g. 'Hello! How can we help you today?'"
                  value={firstChat}
                  onChange={(e) => setFirstChat(e.target.value)}
                />
              </div>

              {/* AI Bot Welcome Message */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    AI Bot Welcome Message
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Set the first welcome message that the AI bot sends to users."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <input
                  type="text"
                  className="form-input"
                  placeholder="e.g. 'Hi there! I'm your AI assistant. What can I help you with?'"
                  value={botFirstChat}
                  onChange={(e) => setBotFirstChat(e.target.value)}
                />
              </div>

              {/* Color Theme */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Color Theme
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Select a color theme that will be applied across the entire chat UI."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <div className="color-dropdown-container">
                  <div
                    className="color-dropdown-selected"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <div className="selected-color-preview">
                      <span
                        className="color-circle"
                        style={{ background: selectedColor }}
                      ></span>
                      {options.find((option) => option.gradient === selectedColor)
                        ?.label || "Custom Color"}
                    </div>
                    <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>
                      <i className="bi bi-chevron-down"></i>
                    </span>
                  </div>

                  {isOpen && (
                    <div className="color-dropdown-options">
                      <div className="custom-color-option">
                        <label>Custom Color</label>
                        <div className="color-picker-container">
                          <input
                            type="color"
                            value={selectedColor}
                            onChange={handleColorChange}
                            className="color-picker"
                          />
                          <span className="color-value">{selectedColor}</span>
                        </div>
                      </div>

                      <div className="theme-separator">
                        <span>Predefined Themes</span>
                      </div>

                      <div className="theme-grid">
                        {options.map((option, index) => (
                          <div
                            key={index}
                            className="theme-option"
                            onClick={() => handleSelect(option)}
                          >
                            <div
                              className="theme-preview"
                              style={{ background: option.gradient }}
                            ></div>
                            <span className="theme-label">{option.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Branding Option */}
              {removeBranding && (
                <div className="setting-card">
                  <div className="setting-card-header">
                    <h4 className="setting-label">Branding Options</h4>
                  </div>
                  <div className="d-flex flex-column mt-2">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        className="checkbox-input"
                        checked={removeBrandingChecked}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkbox-custom"></span>
                      Remove Epic-x Branding
                    </label>
                    <p className="checkbox-description">
                      When enabled, our branding will be hidden from the chat widget.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Save Button */}
            <div className="save-button-container">
              <button
                onClick={handleSave}
                disabled={isSaving}
                className={`save-button ${isSaving ? "saving" : ""}`}
              >
                {isSaving ? (
                  <>
                    <span className="spinner"></span>
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </button>
            </div>
          </div>
        </div>
        {/* Success Notification */}
    {showSuccess && (
      <div className="notification success-notification">
        <svg viewBox="0 0 24 24" className="notification-icon">
          <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
        </svg>
        <span>Settings saved successfully!</span>
      </div>
    )}
    
    {/* Error Notification */}
    {showError && (
      <div className="notification error-notification">
        <svg viewBox="0 0 24 24" className="notification-icon">
          <path fill="currentColor" d="M13 13H11V7H13M13 17H11V15H13M12 2C6.47 2 2 6.5 2 12S6.47 22 12 22 22 17.5 22 12 17.53 2 12 2Z" />
        </svg>
        <span>Error saving settings. Please try again.</span>
      </div>
    )}
      </div>
    </div>
  );
}

export default ChatIcon;